import { FileWarning } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { DisciplinaryReportsPage } from './pages/DisciplinaryReportsPage'
import { DisciplinaryReportPage } from './pages/DisciplinaryReportPage'

export default defineModule({
  id: 'disciplinary-reports',
  name: 'Disciplinary Reports',
  shortName: 'Disciplinary',
  icon: FileWarning,
  navSection: 'admin',
  navOrder: 15,
  urlNamespace: '/disciplinary-reports',
  routes: [
    { path: '/', element: DisciplinaryReportsPage, label: 'Disciplinary Reports' },
    { path: '/new', element: DisciplinaryReportPage, label: 'New Report' },
    { path: '/$reportId', element: DisciplinaryReportPage, label: 'Disciplinary Report' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g d r',

  commandPaletteEntries: [
    {
      label: 'Go to Disciplinary Reports',
      keywords: ['disciplinary', 'writeup', 'warning', 'hr', 'employee', 'discipline', 'edf'],
      path: '/',
      group: 'modules',
      shortcut: 'g d r',
    },
    {
      label: 'New Disciplinary Report',
      keywords: ['new disciplinary', 'write up', 'writeup', 'new warning'],
      path: '/new',
      group: 'actions',
    },
  ],
})
